import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  dir: "ltr",
  class: "text-gray-600"
}
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = { class: "badge-light-info badge" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminsAdvancedSearch = _resolveComponent("AdminsAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'admins'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AdminsAdvancedSearch, {
                onTypeSelected: _ctx.onFilterChange,
                onReset: _ctx.onResetFilters
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.can('create', 'admins'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('admins-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAdmin')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-name": _withCtx(({ row: adminUser }) => [
              _createTextVNode(_toDisplayString(adminUser.name), 1)
            ]),
            "cell-email": _withCtx(({ row: adminUser }) => [
              _createElementVNode("a", {
                href: `mailto:${adminUser.email}`,
                class: "text-gray-600 text-hover-primary mb-1"
              }, _toDisplayString(adminUser.email), 9, _hoisted_9)
            ]),
            "cell-phone": _withCtx(({ row: adminUser }) => [
              (adminUser.phone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(adminUser.phone), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "—"))
            ]),
            "cell-roleName": _withCtx(({ row: adminUser }) => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(adminUser.roleName), 1)
            ]),
            "cell-isActive": _withCtx(({ row: adminUser }) => [
              (adminUser.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: adminUser }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editUser(adminUser.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_15),
              (_ctx.can('remove', 'admins'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusUser(adminUser)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}